import { render, staticRenderFns } from "./definitions.vue?vue&type=template&id=477c1a7f&scoped=true"
import script from "./definitions.vue?vue&type=script&lang=js"
export * from "./definitions.vue?vue&type=script&lang=js"
import style0 from "./definitions.vue?vue&type=style&index=0&id=477c1a7f&prod&scoped=true&lang=css"
import style1 from "./definitions.vue?vue&type=style&index=1&id=477c1a7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477c1a7f",
  null
  
)

export default component.exports